import angular from 'angular';

import { UserService } from './userService';

export const apiServicesModule = angular
  .module('shbdeployer.app.services.api', [])
  .factory('UserService', UserService).name;
